import { render, staticRenderFns } from "./DestinationPicker.vue?vue&type=template&id=6f0a0af0&"
import script from "./DestinationPicker.vue?vue&type=script&lang=ts&"
export * from "./DestinationPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0a0af0')) {
      api.createRecord('6f0a0af0', component.options)
    } else {
      api.reload('6f0a0af0', component.options)
    }
    module.hot.accept("./DestinationPicker.vue?vue&type=template&id=6f0a0af0&", function () {
      api.rerender('6f0a0af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/DestinationPicker.vue"
export default component.exports